var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningWithDot = function SvgWarningWithDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M45.9 19.2c.5 1.8.7 3.6.7 5.6 0 12-9.8 21.8-21.8 21.8C12.7 46.6 3 36.8 3 24.8 3 12.7 12.7 3 24.8 3c3.8 0 7.4 1 10.6 2.7.6-.8 1.3-1.6 2.1-2.2C33.8 1.3 29.4 0 24.8 0 11.1 0 0 11.1 0 24.8s11.1 24.8 24.8 24.8 24.8-11.1 24.8-24.8c0-2.5-.4-4.8-1-7.1q-1.35 1.05-2.7 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M22.3 36.9c0 1.5 1.2 2.8 2.8 2.8 1.5 0 2.8-1.2 2.8-2.8 0-1.5-1.2-2.8-2.8-2.8-1.5 0-2.8 1.2-2.8 2.8m2.8-6.5c.9 0 1.5-.7 1.5-1.5V10.7c0-.8-.7-1.4-1.5-1.4-.9 0-1.5.7-1.5 1.5V29c0 .7.6 1.4 1.5 1.4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.78,
    cy: 10.8,
    r: 7,
    fill: "#EC0000"
  }))));
};
export default SvgWarningWithDot;